export const posts = [
  {
    slug: "welcome-to-olso-labs",
    title: "Welcome to OLSO Labs",
    description: "A quick intro to what we are building and sharing here.",
    cover: "",
    content: `
      <p>Welcome to the OLSO Labs blog.</p>
      <p>This space is for updates, experiments, and project highlights.</p>
    `,
  },
];
